import React, { createContext, useState } from "react";


interface IMenuContext {
  isOpen: boolean;
  toggleMenu: () => void;
  navigateTo: (route: string) => void;
  currentPage: string;
}

const MenuContext = createContext<IMenuContext>({} as IMenuContext)

export const MenuContextProvider: React.FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<string>("");

  function toggleMenu() {
    setIsOpen(old => !old);
  }

  function navigateTo(route: string){
    setCurrentPage(route);
  }

  return (
    <MenuContext.Provider value={{
      isOpen,
      toggleMenu,
      currentPage,
      navigateTo
    }}>
      {children}
    </MenuContext.Provider>
  )
}

export default MenuContext;